export const Types = {
    LOGIN: 'auth/LOGIN',
    UPDATE_USER_DATA: 'auth/UPDATE_USER_DATA',
    LOGOUT: 'auth/LOGOUT',
  };

const initialState = { };

export default function authReducer (state = initialState, action) {
    switch (action.type) {
        case Types.LOGIN:
            return {
                ...state,
                ...action
            };
        case Types.UPDATE_USER_DATA:
            return {
                ...state,
                ...action
            };
        case Types.LOGOUT:
            return {
                ...state,
                ...action
            };
        default:
            return state;
    }
};

export function login(value) {
    return {
        type: Types.LOGIN,
        ...value
    }
}

export function updateUserData(value) {
    return {
        type: Types.UPDATE_USER_DATA,
        ...value
    }
}

export function logout() {
    return {
        type: Types.LOGOUT,
    }
}